<!-- 库存属性调整操作 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                       @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" :show-message="false" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                                               v-if="formOneValue.isShow == 1" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <template>
                                       <!-- 系统字段 -->
                                       <div v-if="formOneValue.isReserved == 0">
                                          <!-- 库房 -->
                                          <el-tooltip v-if="formOneValue.entityField == 'stId'" class="item"
                                                      :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                      effect="dark" :content="sendDataInfo.stName" placement="bottom-start">
                                             <el-input class="form_codition" v-if="formOneValue.entityField == 'stId'" v-model.trim="sendDataInfo.stName" :maxlength="$store.state.inputLength"
                                                       @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.entityField)" :disabled="formOneValue.isChange == 0">
                                                <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField)" slot="append" icon="el-icon-search"></el-button>
                                             </el-input>
                                          </el-tooltip>
                                          <df-date class="form_codition" :isType="true" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" :isShowLong="false"
                                                   v-else-if="formOneValue.entityField == 'chamAppdate'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                          <!-- 申请日期 -->
                                          <!-- 申请理由 -->
                                          <el-input class="form_codition" v-else-if="formOneValue.entityField == 'chamAppreason'" type="textarea" :maxlength="$store.state.inputLength"
                                                    v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0">
                                          </el-input>

                                          <el-input class="form_codition" v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                    :disabled="formOneValue.isChange == 0"></el-input>
                                       </div>
                                       <!-- 扩展字段 -->
                                       <div v-if="formOneValue.isReserved == 1">

                                          <!-- 自填 -->
                                          <el-input class="form_codition" v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength"
                                                    :disabled="formOneValue.isChange == 0"></el-input>

                                          <!-- 选择数据来源 -->
                                          <el-tooltip v-else class="item"
                                                      :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                      effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                             <el-input class="form_codition" v-model.trim="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength"
                                                       @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.entityField)">
                                                <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField)" slot="append" icon="el-icon-search"></el-button>

                                             </el-input>
                                          </el-tooltip>
                                       </div>
                                    </template>

                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                            sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ $common.getIsGsp(formOneValue.formatterContent, sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                    <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                          sendDataInfo[formOneValue.entityField]
                            == 1 ? "是" : "否" }}</span>
                                    <span v-else-if="formOneValue.entityField == 'stId'">{{ sendDataInfo['stName'] }}</span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>

                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="addDetails()">新增</el-button>
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                 </el-button>
                                 <el-button type="primary" size="mini" @click="extract(8820873997127698)">提取</el-button>
                                 <el-tag type="danger" style="margin-left:10px;">库存相关联的业务记录也会同步调整 请谨慎操作！</el-tag>
                              </div>
                              <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.chattdetailAddList" border style="width: 100%" :height="mxHeight">
                                 <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" :label="formOneValue.showField" :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in mxForm"
                                                  :key="formOneKey">
                                    <template slot-scope="scope">
                                       <!-- 系统字段 -->
                                       <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgsId' && dataActionBox.actionType != 2"
                                                 v-model.trim="sendDataInfo.chattdetailAddList[scope.$index].bgsId" :maxlength="$store.state.inputLength"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.entityField, scope.$index)">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, scope.$index)" slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                                 v-model.number="sendDataInfo.chattdetailAddList[scope.$index][formOneValue.entityField]"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)" clearable>
                                          <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, scope.$index, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <!-- 新日期 -->
                                       <df-date :ref="formOneValue.entityField" :isType="true" v-else-if="formOneValue.entityField == 'bgsProdate' && dataActionBox.actionType != 2"
                                                :isdisabled="formOneValue.isChange == 0" v-model="sendDataInfo.chattdetailAddList[scope.$index].bgsProdate" :isShowLong="false"></df-date>
                                       <df-date :ref="formOneValue.entityField" :isType="true" v-else-if="formOneValue.entityField == 'bgsEffdate' && dataActionBox.actionType != 2"
                                                :isdisabled="formOneValue.isChange == 0" v-model="sendDataInfo.chattdetailAddList[scope.$index].bgsEffdate" :isShowLong="false"></df-date>
                                       <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'bgsBatnumber' && dataActionBox.actionType != 2"
                                                 v-model.trim="sendDataInfo.chattdetailAddList[scope.$index].bgsBatnumber" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0">
                                       </el-input>
                                       <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'bgsSbnumber' && dataActionBox.actionType != 2"
                                                 v-model.trim="sendDataInfo.chattdetailAddList[scope.$index].bgsSbnumber" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0">
                                       </el-input>
                                       <!-- 旧日期 -->
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span v-if="scope.row[formOneValue.entityField]">
                                             {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <span v-else>
                                          {{ scope.row[formOneValue.entityField] }}
                                       </span>
                                    </template>
                                 </el-table-column>

                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <!-- 页脚 -->
            <div class="foot">
               <div>
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                  </el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <div v-if="footForm">
                  <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                     <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                        <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                     </el-form-item>
                  </el-form>
               </div>
            </div>
         </div>
      </div>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "attributeAdjustmentAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      // ExtractionScheme,
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         showTabs: "",
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            chamAppdate: "", //申请日期
            chamAppreason: "", //申请理由
            chamReserves1: "", //预留字段
            chamReserves2: "",
            chamReserves3: "",
            chamReserves4: "",
            chamReserves5: "",
            chamReserves6: "",
            totalCount: 0,
            totalMoney: 0,
            totalNumber: 0,
            chattdetailAddList: [], //明细信息
            chattdetailInfoVoList: [],
            stId: 0, //库房id
            stName: "", //库房
            chamId: ''
         },
         detaislDataInfo: {},
         searchInfo: {
            name: "",
         },
         formDataList: [],
         storageRoomList: [],

         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         parentSearchData: {},

         selectedDetailsIndex: 0, //选择索引
         focusIndex: 0, //检索焦点索引
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         newTime: '',
         newDayTime: '',
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.chattdetailAddList": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
            newValue.forEach((item, keys) => {
               if (item.num < 0) {
                  this.sendDataInfo["chattdetailAddList"][keys].num = 0;
                  return false;
               }
               if (item.price < 0) {
                  this.sendDataInfo["chattdetailAddList"][keys].price = 0;
                  return false;
               }
               if (item.money < 0) {
                  this.sendDataInfo["chattdetailAddList"][keys].money = 0;
                  return false;
               }
               if (item.psprice < 0) {
                  this.sendDataInfo["chattdetailAddList"][keys].psprice = 0;
                  return false;
               }
               if (item.psmoney < 0) {
                  this.sendDataInfo["chattdetailAddList"][keys].psmoney = 0;
                  return false;
               }

               // if ((item.bgsProdate > this.newTime) && item.bgsProdate != '') {
               //    item.bgsProdate = this.newTime
               //    this.$refs.bgsProdate[keys].$forceUpdate()
               //    this.$message({
               //       message: "生产日期不能大于今日",
               //       type: "warning",
               //    });
               // }
               this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                  3,
                  NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
               );
               this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                  1,
                  NP.plus(this.sendDataInfo.totalNumber, item.num)
               );
            });
            this.sendDataInfo.totalCount = newValue.length;
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      getTimestamp() {
         this.newTime = new Date(new Date().toLocaleDateString()).getTime() - 1 * 24 * 3600 * 1000
         this.newDayTime = Number(this.$common.getNewDayTime() * 1 + 86400000)
      },
      extract(sId) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = "extract";
         console.log(this.sendDataInfo);
         // this.seIndex
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
               .printJurId)
         } else {
            return
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, type, index) {
         console.log(type);
         if (index) {
            this.focusIndex = index;
         }
         this.DialogVisible = true;
         this.seId = sId;
         this.parentSearchData.stId = this.sendDataInfo.stId;
         this.parentSearchData.stName = this.sendDataInfo.stName;
         if (type == "bgsId") {
            console.log(this.sendDataInfo.chattdetailAddList[index], this.sendDataInfo.chattdetailAddList);
            this.parentSearchData.bgmName = this.sendDataInfo.chattdetailAddList[index].bgsstockLnventoryPlanId
         }
         if (type == "lotno") {
            for (const key in this.sendDataInfo.chattdetailAddList[index]) {
               this.parentSearchData[key] =
                  this.sendDataInfo.chattdetailAddList[index][key];
            }
         }
      },
      //检索带回数据
      changeInputModel(val) {
         // console.log("返hui", val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口
            if (val.length > 0) {
               if (val[0].stId) {
                  //为库房时
                  this.sendDataInfo.stId = val[0].stId;
                  this.sendDataInfo.stName = val[0].stName;
                  this.sendDataInfo.bgsId = val[0].bgsId;
               }
               this.bgmSelect(val)
               return
            }
            if (val.stId) {
               //为库房时
               this.sendDataInfo.stId = val.stId;
               this.sendDataInfo.stName = val.stName;
               this.sendDataInfo.bgsId = val.bgsId;
            }
            //赋值给当前行
            if (val.bgmId) {
               console.log(val, this.sendDataInfo.chattdetailAddList, this.focusIndex)
               if (this.sendDataInfo.chattdetailAddList.length == 0) {
                  this.addDetails()
               }
               setTimeout(() => {
                  for (const key in val) {
                     if (Object.hasOwnProperty.call(val, key)) {
                        this.$set(
                           this.sendDataInfo.chattdetailAddList[this.focusIndex],
                           key,
                           val[key]
                        );
                     }
                  }
               }, 15)
            }
         } else {
            this.DialogVisible = false;
            this.$message({
               message: "检索失败",
               type: "error",
            });
         }
      },
      bgmSelect(val) {
         if (this.sendDataInfo.chattdetailAddList.length == 0) {
            this.sendDataInfo.chattdetailAddList = val
         } else {
            this.sendDataInfo.chattdetailAddList.splice(this.focusIndex, 1)
            val.forEach(item => {
               //赋值给当前行
               if (item.bgmId) {
                  setTimeout(() => {
                     this.sendDataInfo.chattdetailAddList.push({})
                     var index = this.sendDataInfo.chattdetailAddList.length - 1
                     for (const key in item) {
                        if (Object.hasOwnProperty.call(item, key)) {
                           this.$set(
                              this.sendDataInfo.chattdetailAddList[index],
                              key,
                              item[key]
                           );
                        }
                     }
                  }, 15)
               }
            })
         }

      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      // 确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) { } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
         if (flag) return false;
         if (this.sendDataInfo.bgsId == "") {
            this.$message({
               message: "请选择库存",
               type: "error",
            });
            return false;
         }

         // console.log("gai", this.sendDataInfo);
         let responseData;
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.addAttributeAdjustment(
               this.sendDataInfo
            );
         } else {
            responseData = await this.$http.setAttributeAdjustment(
               this.sendDataInfo
            );
         }
         if (responseData.status == 200) {
            this.$emit('drawerCancel', 1)
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });

            // this.$parent.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //取消新增
      initActionBox(formName) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit('drawerCancel', 0)
               this.init();
               this.$refs[formName].resetFields();
            })
            .catch(() => { });
      },

      // 初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量

         this.sendDataInfo.chamAppdate = new Date().getTime(); //申请时间
         this.sendDataInfo.chattdetailAddList = [];
      },

      //新增明细
      addDetails() {
         if (this.sendDataInfo.stId == "") {
            //必须先选库房
            this.$message({
               message: "请先选择库房",
               type: "error",
            });
            return false;
         }
         var flag = false
         if (this.sendDataInfo.chattdetailAddList.length > 0) {
            this.sendDataInfo.chattdetailAddList.forEach(item => {
               if (item.bgsId == "") {
                  flag = true
                  this.$nextTick(() => {
                     this.selectedDetailsIndex = Number(
                        this.sendDataInfo.chattdetailAddList.length - 1
                     );
                     this.tableNextFocus("bgsId", this.selectedDetailsIndex);
                     let refsElTable = this.$refs.mxTableRef;
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.chattdetailAddList[this.selectedDetailsIndex]
                     );
                  });
               }
            })
         }
         if (flag) {
            return
         }
         this.sendDataInfo.chattdetailAddList.push({})
         var index = this.sendDataInfo.chattdetailAddList.length - 1
         for (const key in this.detaislDataInfo) {
            this.$set(this.sendDataInfo.chattdetailAddList[index], key, this.detaislDataInfo[key])
         }
         this.$nextTick(() => {
            this.selectedDetailsIndex = Number(
               this.sendDataInfo.chattdetailAddList.length - 1
            );
            this.tableNextFocus("bgsId", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
               this.sendDataInfo.chattdetailAddList[this.selectedDetailsIndex]
            );
         });
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
               this.$refs["bgsId"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.chattdetailAddList.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.sendDataInfo.chattdetailAddList.splice(this.selectedDetailsIndex, 1);
         this.selectedDetailsIndex = 0;
      },

      // 获取所有可用库房列表
      async getAllStorageRoom() {
         let responseData = await this.$http.getAllStorageRoom();
         if (responseData.status == 200) {
            this.storageRoomList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      async isShowData(name, value) {
         switch (name) {
            case "cargoOwner":
               var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.coId = dataInfo.coId;
                  this.sendDataInfo.newCoName = dataInfo.coName;
               }
               break;
         }
      },

      // 父级传入
      openBox(cate, formData, oldData = "") {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData
         var oldData = this.actionData.oldData
         this.filterMainField()
         this.init();
         this.showTabs = this.actionData.formData[0].jciName
         let chattdetailAddList = [];

         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
            for (let key in this.sendDataInfo) {
               if (key == "chattdetailInfoVoList") {
                  dataInfo.chattdetailInfoVoList.forEach((item) => {
                     let itemObj = {}
                     for (const ks in item) {
                        if (ks == 'bgsOldbatnumber') { //原批号-批号
                           itemObj['batchno'] = item[ks];
                        } else if (ks == 'bgsOldprodate') { //原生产日期-生产日期
                           itemObj['prodate'] = item[ks];
                        } else if (ks == 'bgsOldeffdate') { //原有效期-失效日期
                           itemObj['expidate'] = item[ks];
                        } else if (ks == 'bgsOldsbnumber') { //原灭菌批号-灭菌批号
                           itemObj['sterBatchno'] = item[ks];
                        } else {
                           itemObj[ks] = item[ks];
                        }
                     }

                     chattdetailAddList.push(itemObj)
                  });
               }
            }
            this.sendDataInfo.chattdetailAddList = chattdetailAddList;
         } else {
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
            for (let key in dataInfo) {
               if (key == "chattdetailInfoVoList") {
                  this.sendDataInfo.chattdetailAddList = this.sendDataInfo[key]
               }
            }
            this.sendDataInfo.chattdetailAddList.forEach(item => {
               item['batchno'] = item['bgsOldbatnumber'];
               item['prodate'] = item['bgsOldprodate'];
               item['expidate'] = item['bgsOldeffdate'];
               item['sterBatchno'] = item['bgsOldsbnumber'];
            })
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
            }, 16.7)
         })
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.detaislDataInfo, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "")
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                  .jurconfigform[index])
            }
         })
         var arr = [{ entityField: "chattdetailAddList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "chamAppdate", new Date().getTime())
         this.$set(this.sendDataInfo, "actionType", 0)
      }
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
      this.getTimestamp()
      this.getAllStorageRoom();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>